var _path, _ellipse, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSurf(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    enableBackground: "new 0 0 100 100",
    fill: "#FFFFFF",
    viewBox: "0 0 100 100",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m16.6 82.6c1.2 0.2 2.5 0.3 3.9 0.3 5 0 8.7-1.5 10-3 1.2-1.3 2.9-2 4.7-2s3.5 0.7 4.7 2c1.4 1.4 5.1 3 10 3 5 0 8.7-1.5 10-3 1.2-1.3 2.9-2 4.7-2s3.5 0.7 4.7 2c1 1.1 3.5 2.3 6.8 2.7 9-3.9 14.6-8.3 14.3-10-0.4-2.4-13.4-6.5-29.9-5.7-1.7-4.7-3.7-9.6-5-11.1-1.2-1.4-5.4-5-8.2-7.3l1.7-17.1c6.4-0.3 18.4-1.2 19-1.3 1.8-0.1 3.2-1.7 3-3.6-0.1-1.8-1.7-3.2-3.5-3-0.2 0-17.6 1.3-21.6 1.4h-4.5-5.4c-2.4 0-8.8 0.1-10.5-0.7-0.5-0.9-0.8-4-0.6-6.6 0.1-1.8-1.3-3.4-3.1-3.5s-3.4 1.3-3.5 3.1c-0.2 2.7-0.3 9.4 2.9 12.1 2.3 1.9 6.7 2.3 12.4 2.3l-1 18c-0.9 2.2-2.9 7.3-3.2 10.2-0.2 2.6 0.6 9.4 1.1 13.1-7.7 3-13.1 6.5-13.9 9.7zm20.9-22.1c0.1-1.5 1.6-5.6 2.7-8.2 0.1 0.2 0.3 0.3 0.5 0.5 3.9 3.2 8.5 7.2 9.2 8 0.5 0.7 1.7 3.7 3 7-0.3 0-0.5 0.1-0.8 0.1-4.9 0.7-9.4 1.7-13.6 2.8-0.7-4.2-1.2-8.8-1-10.2z"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(1 -.0075869 .0075869 1 -.1127 .3167)",
    cx: 41.7,
    cy: 15,
    rx: 7.7,
    ry: 7.7
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m96.5 82.1c-1.3-1.2-3.4-1.2-4.6 0.1-2.3 2.4-7.2 4-12.4 4s-10.1-1.6-12.4-4c-1.2-1.3-3.5-1.3-4.7 0-2.3 2.4-7.2 4-12.4 4s-10.1-1.6-12.4-4c-1.2-1.3-3.5-1.3-4.7 0-2.3 2.4-7.2 4-12.4 4s-10.1-1.6-12.4-4c-1.2-1.3-3.3-1.4-4.6-0.1-1.3 1.2-1.4 3.3-0.1 4.6 3.6 3.8 10 6 17.1 6 5.8 0 11-1.5 14.7-4 3.7 2.5 9 4 14.7 4 5.8 0 11.1-1.5 14.8-4 3.7 2.5 9 4 14.7 4 7.1 0 13.5-2.2 17.1-6 1.3-1.3 1.3-3.4 0-4.6z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSurf);
export default __webpack_public_path__ + "static/media/SURF.044c65f3c4c57482883e70692cfcf22f.svg";
export { ForwardRef as ReactComponent };